/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
import { url } from 'utils/urls';
// material
import { Logo, Page, Group, Copy, Title, BodyCopy, CTAs, Button, getCookie } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/signupcomplete/signupcomplete_styles';



/* ========== ~~~~~~~~~~ AUTH SIGNUP COMPLETE ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => (
    <Page name={`signupcomplete`} klass={props.classes.signupcompletepage}>
        <Group name={`main`}>
            <Copy>
                <Title>
                    <Logo/>
                </Title>
                <BodyCopy>
                    <h1>All set!</h1>
                    <p className={'congrats'}>Congratulations, your signup is now complete.</p>
                    <CTAs>
                        <Button disabled={false}
                                variant={'primary'}
                                type={'action'}
                                action={() => {
                                    props.setSessionData({ showSetPassword: false, showTermsAndConditions: false });
                                    if(getCookie('auto_login_pub_portal_v2') === 'true') {
                                        window.open(`https://publisher-portal.${url.baseURL}`, '_self')
                                    } else {
                                        props.moveToPage('dashboard/home')
                                    }
                                }}
                                text={'Go to your publisher portal'} />
                    </CTAs>
                </BodyCopy>
            </Copy>
        </Group>
    </Page>
))
